import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/vercel/path0/web/app/(app)/app-shell.tsx");
